<template>
    <div id="category">
        <nav-bar></nav-bar>
        <div style="margin-top: 60px;text-align: center;" v-if="showLoading">
            <van-loading color="#1989fa">
            </van-loading>
        </div>
        <div class="goods-category-left" v-if="!showLoading">
            <div class="oneNav">
                <!-- vant侧边导航 -->
                <van-sidebar v-model="activeKey" color="#1989f9">
                  <div v-if="langType=='cn'">
                    <van-sidebar-item
                        v-for="(item,index) in oneClass"
                        :title="item.nameCn"
                        @click="oneNav(index)"/>
                  </div>
                  <div v-if="langType=='en'">
                    <van-sidebar-item
                        v-for="(item,index) in oneClass"
                        :title="item.nameEn"
                        @click="oneNav(index)"/>
                  </div>
                </van-sidebar>

            </div>
            <div class="twoNav">
                <div style="padding-top: 20px"></div>
                <!-- vant宫格 -->
                <category-list :categoryList="twoClass" />
            </div>
        </div>
    </div>
</template>

<script>
    import NavBarIndexContent from "@/components/content/navbar/NavBarIndexContent";
    import { getCategory } from "@/network/category/category";
    import {Sidebar, SidebarItem, Image, Grid, GridItem, Loading} from 'vant';
    import categoryList from "@/components/content/category/categoryList";
    import { langPackage } from "@/config/lang/goodsInfoLang";
    import { selectLang } from "@/config/setLanguage"
    export default {
        name: "Category",
        components: {
            NavBar: NavBarIndexContent,
            categoryList:categoryList,
            [Sidebar.name]: Sidebar,
            [SidebarItem.name]: SidebarItem,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Image.name]: Image,
            [Loading.name]: Loading
        },
        data(){
            return{
                oneClass:[], //一级分类数据
                activeKey:0,
                twoClass:[], //二级分类数据
                showLoading: true,
                classIndex: 0,
                classTitle: "精选分类",//分类title
                categoryId:null,
                vipStatus:0,
                langType:"cn"
            }
        },
        methods:{
            oneNav(index){ //点击一级导航切换
                getCategory({parentId:this.oneClass[index]['id'],vipStatus:this.vipStatus}).then(res => {
                    this.twoClass = res.data
                })
            },
            //点击二级导航跳转列表页
            onList(id, pid){
                this.$router.push({
                    path:'/goods/goodsList',
                    query:{
                        categoryId: id,
                        categoryPid: pid,
                        oneActive: this.activeKey
                    }
                })
            },
          getClassTwo(id){
            //获取二级分类
            getCategory({parentId:id,vipStatus:this.vipStatus}).then(res =>{
              this.twoClass=res.data
            });
          },
        },
        created() {
          //获取语言包
          selectLang(langPackage).then(langtxt =>{
            this.langText = langtxt.langtxt;
            this.commonText = langtxt.common;
            this.langType = langtxt.type;
          });
            //获取一级分类
            getCategory({parentId:this.classIndex,vipStatus:this.vipStatus}).then(res => {
                this.showLoading = false
                this.oneClass = res.data;
              //获取二级分类 第一个分类
              if(res.data[0].id){
                this.getClassTwo(res.data[0].id);
              }
            })
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";


    .goods-category-left {
        overflow: hidden;
        position: absolute;
        top: 44px;
        bottom: 49px;
        left: 0;
        right: 0;
        background-color: #f9f9f7;
        display: flex;
    }
    .oneNav {
        width: 25%;
        height: 100%;
        white-space: nowrap;
        overflow-y: scroll;
    }
    .twoNav {
        width: 75%;
        overflow-y: auto;
        overflow-x: hidden;
        /*-webkit-overflow-scrolling: touch;*/
        height: 100%;
        float: left;
    }

    .van-sidebar::-webkit-scrollbar {
        display: none;
    }

</style>
